import React from 'react';
import {BaseIcon, iconDefaultProps, iconPropTypes} from './base-icon';
export const TimeEntryIcon = ({...props}) => (
	<BaseIcon {...props}>
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.32222 3.6C8.32222 3.26863 8.05359 3 7.72222 3C7.39085 3 7.12222 3.26863 7.12222 3.6V4.45001H6C4.34315 4.45001 3 5.79316 3 7.45001V18C3 19.6569 4.34315 21 6 21H10C10.3314 21 10.6 20.7314 10.6 20.4C10.6 20.0686 10.3314 19.8 10 19.8H6C5.00589 19.8 4.2 18.9941 4.2 18V9.28966H19.8V9.72501C19.8 10.0564 20.0686 10.325 20.4 10.325C20.7314 10.325 21 10.0564 21 9.72501V7.45001C21 5.79316 19.6569 4.45001 18 4.45001H15.8778V3.6C15.8778 3.26863 15.6091 3 15.2778 3C14.9464 3 14.6778 3.26863 14.6778 3.6V4.45001H8.32222V3.6ZM19.8 8.08966V7.45001C19.8 6.4559 18.9941 5.65001 18 5.65001H15.8778V6.42759C15.8778 6.75896 15.6091 7.02759 15.2778 7.02759C14.9464 7.02759 14.6778 6.75896 14.6778 6.42759V5.65001H8.32222V6.42759C8.32222 6.75896 8.05359 7.02759 7.72222 7.02759C7.39085 7.02759 7.12222 6.75896 7.12222 6.42759V5.65001H6C5.00589 5.65001 4.2 6.4559 4.2 7.45001V8.08966H19.8Z"
				fill="#4C4C58"
			/>
			<path
				d="M16 13.5954C16.3314 13.5954 16.6 13.864 16.6 14.1954V15.7515L18.2243 17.3758C18.4586 17.6101 18.4586 17.99 18.2243 18.2243C17.9899 18.4586 17.61 18.4586 17.3757 18.2243L15.5757 16.4243C15.5182 16.3668 15.4748 16.3005 15.4455 16.2297C15.4162 16.159 15.4 16.0814 15.4 16V14.1954C15.4 13.864 15.6686 13.5954 16 13.5954Z"
				fill="#4C4C58"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16 21.5C19.0376 21.5 21.5 19.0376 21.5 16C21.5 12.9625 19.0376 10.5 16 10.5C12.9624 10.5 10.5 12.9625 10.5 16C10.5 19.0376 12.9624 21.5 16 21.5ZM16 20.3C18.3748 20.3 20.3 18.3748 20.3 16C20.3 13.6252 18.3748 11.7 16 11.7C13.6252 11.7 11.7 13.6252 11.7 16C11.7 18.3748 13.6252 20.3 16 20.3Z"
				fill="#4C4C58"
			/>
		</svg>
	</BaseIcon>
);

TimeEntryIcon.propTypes = iconPropTypes;
TimeEntryIcon.defaultProps = iconDefaultProps;
